import type { MulticallBatchOptions, Prettify } from 'viem'

import { mapObjValues } from '@repo/utils'

type BatchOptions = {
  multicall?: boolean | Prettify<MulticallBatchOptions>
}

type PerChainBatchOptions = {
  [chainId: number]: BatchOptions
}

type Batch = BatchOptions | PerChainBatchOptions | undefined

function isBatchOptions(b: BatchOptions | PerChainBatchOptions): b is BatchOptions {
  return Object.prototype.hasOwnProperty.call(b, 'multicall')
}

/**
 * Limits user-specified wagmi/viem batch options so as not to exceed `maxCalldataBytes`.
 *
 * @param batch Arbitrary wagmi/viem batch options
 * @param maxCalldataBytes Maximum calldata size in bytes
 * @returns A new `batch` object with options updated where necessary
 */
export function limitBatchCalldataBytes(batch: Batch, maxCalldataBytes: number): Batch {
  if (!batch) return { multicall: { batchSize: maxCalldataBytes } }

  if (isBatchOptions(batch)) {
    const mc = batch.multicall
    if (mc && typeof mc === 'object') {
      return { ...batch, multicall: { ...mc, batchSize: maxCalldataBytes } }
    }
    return batch
  }

  return mapObjValues(batch, v => limitBatchCalldataBytes(v, maxCalldataBytes))
}
